<template>
  <div>
    <el-row style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="24"> 代采版偏好设置 </el-col>
    </el-row>

    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      开单-报单页面,商家代采计划列表的微信分享文案
    </el-row>
    <el-row>
      <el-input
        v-model="kdbd_text"
        :rows="5"
        type="textarea"
        placeholder=""
        style="width: 600px"
      ></el-input>
    </el-row>
    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      开单-核单页面,商家代采订单列表的微信分享文案
    </el-row>
    <el-row>
      <el-input
        v-model="kdhd_text"
        :rows="5"
        type="textarea"
        placeholder=""
        style="width: 600px"
      ></el-input>
    </el-row>
    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      开单-回执页面,财务付款拼争列表的微信分享文案
    </el-row>
    <el-row>
      <el-input
        v-model="kdhz_text"
        :rows="5"
        type="textarea"
        placeholder=""
        style="width: 600px"
      ></el-input>
    </el-row>
    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      报单-代采计划商品列表的微信分享文案
    </el-row>
    <el-row>
      <el-input
        v-model="cgjh_text"
        :rows="5"
        type="textarea"
        placeholder=""
        style="width: 600px"
      ></el-input>
    </el-row>
    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      回执-财务已支付的付款回执微信分享文案
    </el-row>
    <el-row>
      <el-input
        v-model="fkhz_text"
        :rows="5"
        type="textarea"
        placeholder=""
        style="width: 600px"
      ></el-input>
    </el-row>
    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      爆版订货单-今日实时订单池 提示文案
    </el-row>
    <el-row>
      <el-input
        v-model="bbdhd_text"
        :rows="5"
        type="textarea"
        placeholder=""
        style="width: 600px"
      ></el-input>
    </el-row>
    <el-row style="height: 50px; font-size: 15px; line-height: 50px">
      代采版待开单页面，商家名称“红色”显示设置
    </el-row>
    <el-row>
      商家代采计划超过
      <el-input
        v-model="overdue_day"
        type="text"
        placeholder=""
        style="width: 100px"
      ></el-input>
      天还没进行操作
    </el-row>
    <el-row>
      采购计划待开单超过
      <el-input
        v-model="outdo_day"
        type="text"
        placeholder=""
        style="width: 100px"
      ></el-input>
      天自动加入急救箱，同时商品库
      <el-select v-model="is_disable" filterable>
        <el-option value="1" label="商品货号禁用"></el-option>
        <el-option value="2" label="不改动"></el-option>
      </el-select>
    </el-row>
    <el-row>
      SKU单日备货件数大于
      <ys-input
        v-model="limit_no_pre_storage_sku"
        pattern="positiveInt"
        placeholder=""
        style="width: 100px"
      ></ys-input>
      件，非前置仓的备货计划需要审核
    </el-row>
    <el-row>
      前置仓库存里，当某SKU寄售期（最早的一件）超过
      <ys-input
        v-model="pre_stock_advent_day"
        pattern="positiveInt"
        placeholder="填写天数"
        style="width: 150px"
      ></ys-input>
      天，将通知商家即将退供（SKU的所有库存）。超过
      <ys-input
        v-model="pre_stock_auto_return_day"
        pattern="positiveInt"
        placeholder="填写天数"
        style="width: 150px"
      ></ys-input>

      天，将自动生产退供单进入退供流程。
    </el-row>
    <el-row style="height: 80px; font-size: 15px; line-height: 50px">
      <el-button
        style="width: 80px; margin-top: 30px; margin-left: 625px"
        type="info"
        @click="cancel"
        >取消</el-button
      >
      <el-button style="width: 80px" type="warning" @click="submit">
        保存
      </el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ShareText",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      kdbd_text: "",
      kdhd_text: "",
      kdhz_text: "",
      cgjh_text: "",
      fkhz_text: "",
      bbdhd_text: "",
      overdue_day: "",
      limit_no_pre_storage_sku: "",
      pre_stock_advent_day: "",
      pre_stock_auto_return_day: "",
      outdo_day: "30",
      is_disable: "1",
    };
  },
  methods: {
    fetchData() {
      const url = "/erp/ShareText/getShareContent";
      const args = "";
      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.kdbd_text = res.data.data.kdbd_text;
          this.kdhd_text = res.data.data.kdhd_text;
          this.kdhz_text = res.data.data.kdhz_text;
          this.cgjh_text = res.data.data.cgjh_text;
          this.fkhz_text = res.data.data.fkhz_text;
          this.bbdhd_text = res.data.data.bbdhd_text;
          this.overdue_day = res.data.data.overdue_day;
          this.limit_no_pre_storage_sku =
            res.data.data.limit_no_pre_storage_sku;
          this.pre_stock_advent_day = res.data.data.pre_stock_advent_day;
          this.pre_stock_auto_return_day =
            res.data.data.pre_stock_auto_return_day;
          this.outdo_day = res.data.data.outdo_day;
          this.is_disable = res.data.data.is_disable;
        }
      });
    },
    cancel() {
      this.$router.go(0);
    },
    submit() {
      const url = "/erp/ShareText/editShareContent";
      const args = {
        kdbd_text: this.kdbd_text,
        kdhd_text: this.kdhd_text,
        kdhz_text: this.kdhz_text,
        cgjh_text: this.cgjh_text,
        fkhz_text: this.fkhz_text,
        bbdhd_text: this.bbdhd_text,
        overdue_day: this.overdue_day,
        limit_no_pre_storage_sku: this.limit_no_pre_storage_sku,
        pre_stock_auto_return_day: this.pre_stock_auto_return_day,
        pre_stock_advent_day: this.pre_stock_advent_day,
        outdo_day: this.outdo_day,
        is_disable: this.is_disable,
      };
      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$notify({
            title: "操作成功",
            message: "",
            type: "success",
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ShareText.vue